<template >
  <v-container>
    <form>
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="signatureContainer">
              <VueSignaturePad
                width="100%"
                height="200px"
                ref="signaturePad"
                :options="options"
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" cols="12" class="text-center">
            <v-btn min-width="200px" @click="undoSignature" color="primary">{{
              $t("undo")
            }}</v-btn>
          </v-col>
          <v-col md="4" cols="12" class="text-center">
            <v-btn min-width="200px" @click="reloadSignature" color="primary">{{
              $t("reload")
            }}</v-btn>
          </v-col>
          <v-col md="4" cols="12" class="text-center">
            <v-btn min-width="200px" @click="clearSignature" color="primary">{{
              $t("reset")
            }}</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn min-width="200px" @click="updateSignature" color="success">{{
              $t("update_signature")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";
import VueSignaturePad from "vue-signature-pad";

export default {
  name: "user-edit-signature",
  props: {
    masterId: null,
  },
  components: {
    VueSignaturePad,
  },
  data() {
    return {
      signature: null,
      options: {
        penColor: "#c0f",
      },
    };
  },
  methods: {
    loadData() {
      let _ = this;
      let url = "/auth/portal/getUserSignature/";
      if (_._props.masterId) url += _._props.masterId;
      _.$refs.signaturePad.clearSignature();

      _.chiamataAxios("GET", url).then((response) => {
        _.signature = response.data.signature;
        _.$refs.signaturePad.resizeCanvas();
        _.$refs.signaturePad.fromDataURL(_.signature);
      });
    },
    undoSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    reloadSignature() {
      this.loadData();
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    updateSignature: function () {
      let _ = this;
      const signature = _.$refs.signaturePad.saveSignature();
      if (!signature.isEmpty) _._data.signature = signature.data;
      else _._data.signature = "";
      let url = "/auth/portal/setUserSignature/";
      if (_._props.masterId) url += _._props.masterId;
      _.chiamataAxios("POST", url, {
        body: {
          signature: _._data.signature,
        },
      }).then((response) => {
        Swal.fire({
          type: response.msg.esito ? "success" : "error",
          title: response.msg.esito
            ? _.$t("operation_successfully_completed")
            : _.$t("there_was_an_error"),
          html: response.msg.msgTxt,
        });
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
  display: function (value) {
    this.$nextTick(function () {
      this.loadData();
    });
  },
};
</script>
<style lang="scss" scoped>
.signatureContainer {
  border: 1px solid lightgrey;
  border-radius: 5px;
}
</style>
